import { useRef, useState } from "react";
import { Input } from "@/components/ui/input";
import { Button } from "@/components/ui/button";
import { MagnifyingGlass, Barcode, Calculator } from "@phosphor-icons/react";
import BarcodeScanner from "@/components/BarcodeScanner";
import { useNumpad } from "@/lib/numpad-context";

export default function CustomerLookupBar({ value, onChange, onSearch, searching }) {
    const numpad = useNumpad();
    const [scannerOpen, setScannerOpen] = useState(false);
    const inputRef = useRef(null);

    const handleScanned = (text) => {
        onChange((text || "").trim());
        setScannerOpen(false);
        // Auto-search after scan
        setTimeout(() => onSearch((text || "").trim()), 50);
    };

    const toggleNumpad = () => {
        if (numpad.isOpen) {
            numpad.close();
            return;
        }
        numpad.open({
            value: value || "",
            label: "Αναζήτηση πελάτη →",
            onChange,
            onApply: (v) => v && onSearch(v),
        });
        setTimeout(() => inputRef.current?.focus(), 50);
    };

    return (
        <div className="bg-white border-2 border-[#0A0A0A] p-3" data-testid="customer-lookup-bar">
            <form
                onSubmit={(e) => {
                    e.preventDefault();
                    onSearch(value);
                }}
                className="flex gap-2 items-center"
            >
                <div className="text-[10px] font-bold uppercase tracking-[0.25em] text-[#5C5F66] shrink-0">
                    ΑΝΑΖΗΤΗΣΗ →
                </div>
                <div className="relative flex-1">
                    <MagnifyingGlass
                        size={18}
                        className="absolute left-3 top-1/2 -translate-y-1/2 text-[#5C5F66]"
                        weight="bold"
                    />
                    <Input
                        ref={inputRef}
                        value={value}
                        onChange={(e) => onChange(e.target.value)}
                        placeholder="Κωδικός / ΑΦΜ / QR / Barcode πελάτη..."
                        data-testid="cust-lookup-input"
                        className="rounded-none h-12 pl-10 text-base font-semibold border-[#0A0A0A] border-2"
                    />
                </div>
                <Button
                    type="button"
                    onClick={() => setScannerOpen(true)}
                    data-testid="cust-lookup-scan"
                    className="rounded-none h-12 px-4 bg-white border-2 border-[#0A0A0A] text-[#0A0A0A] hover:bg-[#0A0A0A] hover:text-white font-bold"
                >
                    <Barcode size={20} weight="bold" />
                </Button>
                <Button
                    type="button"
                    onClick={toggleNumpad}
                    data-testid="cust-lookup-numpad"
                    className={`rounded-none h-12 px-4 border-2 border-[#5856D6] font-bold ${
                        numpad.isOpen
                            ? "bg-[#5856D6] text-white"
                            : "bg-white text-[#5856D6] hover:bg-[#5856D6] hover:text-white"
                    }`}
                >
                    <Calculator size={20} weight="bold" />
                </Button>
                <Button
                    type="submit"
                    disabled={searching}
                    data-testid="cust-lookup-submit"
                    className="rounded-none h-12 px-6 bg-[#002FA7] hover:bg-[#001D66] text-white font-bold"
                >
                    {searching ? "..." : "ΑΝΑΖΗΤΗΣΗ"}
                </Button>
            </form>

            <BarcodeScanner
                open={scannerOpen}
                onClose={() => setScannerOpen(false)}
                onScan={handleScanned}
            />
        </div>
    );
}
